import { getFullName } from '@provision/formatting-utils';
import { getStatusDisplay } from 'src/graphql/entities/conversation-status';
import { NotificationRaw } from 'src/types';
import { parseJsonSafely } from 'src/utils/objects';
import { NOTIFICATION_EVENT_TO_STATUS_ICON_MAP } from './constants';
import {
  Notification,
  NotificationChannelType,
  NotificationEvent,
  NotificationStatus,
} from './notification.types';

export const mapNotificationRecord = (notification: NotificationRaw): Notification => {
  return {
    ...notification,
    parsedPayload: parseJsonSafely<Notification['parsedPayload']>(notification.payload),
    notificationChannelId: notification.notificationChannelId as NotificationChannelType,
    status: notification.status as NotificationStatus,
    notificationEventId: notification.notificationEventId as NotificationEvent,
    author: getAuthor(notification),
    entityStatus: getStatusIconData(notification),
  };
};

function getAuthor(notification: NotificationRaw) {
  const { platformUserFlowInitiator, clientFlowInitiator } = notification;

  const entityData = platformUserFlowInitiator || clientFlowInitiator;

  return {
    id: entityData?.id ?? '',
    firstName: entityData?.firstName ?? '',
    lastName: entityData?.lastName ?? '',
    fullName: getFullName(entityData),
  };
}

function getStatusIconData(notification: NotificationRaw) {
  if (notification.entity === 'Conversation') {
    const parsedPayload = parseJsonSafely<Notification['parsedPayload']>(notification.payload);

    const status = parsedPayload?.conversation?.status;
    const statusDisplay = getStatusDisplay(status?.id);

    return {
      icon: statusDisplay.icon,
      library: statusDisplay.library,
      colorPath: statusDisplay.color,
      tooltip: status?.name ?? '',
    };
  }

  return {
    icon:
      NOTIFICATION_EVENT_TO_STATUS_ICON_MAP[
        notification.notificationEventId as NotificationEvent
      ] || 'inbox',
    colorPath: 'custom.OV.sys.primary',
    tooltip: '',
  };
}
